/**
 * CapabilityBadge - Displays a product capability with status indicator
 * Pure presentational component wrapped with React.memo
 */

import { memo } from 'react';
import type { Capability } from '../../../types';
import { capabilityStatusColors, capabilityStatusLabels } from './constants';

interface CapabilityBadgeProps {
  capability: Capability;
}

function CapabilityBadgeComponent({ capability }: CapabilityBadgeProps) {
  const colors = capabilityStatusColors[capability.status];
  return (
    <div className={`rounded-lg px-3 py-2 ${colors.bg}`} title={capability.description}>
      <div className={`text-sm font-medium ${colors.text}`}>{capability.name}</div>
      <div className={`text-xs ${colors.text} opacity-75`}>
        {capabilityStatusLabels[capability.status]}
      </div>
    </div>
  );
}

export const CapabilityBadge = memo(CapabilityBadgeComponent);
